<div style="max-width: 400px;">
  <h1 mat-dialog-title>Rolle ändern</h1>
  <mat-dialog-content style="overflow: hidden;">

    <div style="height: 80px">
      <form
        (keyup.enter)="updateUserRole()" (ngSubmit)="updateUserRole()" tabindex="0" [formGroup]="roleFormGroup">
        <mat-form-field appearance="outline" class="no-padding">
          <mat-label>Rolle</mat-label>
          <mat-select formControlName="roleInput">
            @for (role of roleList; track role) {
              <mat-option [value]="role">{{role}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button aria-label="Save role" color="primary" mat-raised-button matSuffix type="submit">
          <div class="center-content">
            <mat-icon>check</mat-icon>
          </div>
        </button>
      </form>
    </div>

  </mat-dialog-content>
</div>
